<template>
<v-container fluid class="pa-0">
    <v-toolbar class="elevation-2" height="48px">
        <v-btn icon href="/#/sar/"><v-icon>mdi-arrow-left-thick</v-icon></v-btn>
        <v-toolbar-title >Petite région agricole </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-chip outlined color="blue" v-if="form.sar_updated_at">
            <v-icon left>mdi-information-outline</v-icon>Modification: {{ locDateFormat.formatLocale(form.sar_updated_at, 'fr') }}
        </v-chip>
    </v-toolbar>
<!-- Formulaire -->
    <v-card fluid class="ma-2 pa-5 elevation-2">
        <v-layout row wrap>
        <v-flex xs12 class="pa-2">
            <v-text-field label="Nom"     v-model="form.sar_name" ></v-text-field>
        </v-flex>
        <v-flex xs6 class="pa-2">
            <v-text-field label="Code"    v-model="form.sar_code" ></v-text-field>
        </v-flex>
        <v-flex xs6 class="pa-2">
            <v-text-field label="Code region"    v-model="form.sar_reg_code" ></v-text-field>
        </v-flex>
        <v-flex xs6 class="pa-2">
            <auto-multi v-if="!loading.getItem" :title="'Département associé'" ressource="department" :listObject.sync="autoComplete.sar_dep_id"
                :listParent.sync="autoCompleteSource.dep" 
                :fields="{ index: 'dep_id', text:'dep_name', search:'dep_name,dep_code', preprendIcon:'mdi-map-search', multiSelect:false, }"
                class="ml-2 mr-2">
            </auto-multi>
        </v-flex>
        <v-flex xs3 class="pa-2">
            <v-checkbox :true-value="1" :false-value="0" v-model="form.sar_concerned" label="Région concernée"></v-checkbox>
        </v-flex>
        <v-flex xs3 class="pa-2">
            <v-text-field label="Ordre"  type="number"  v-model="form.sar_order" ></v-text-field>
        </v-flex>
        </v-layout>
    </v-card>
    <div class="ma-4 text-right">
        <v-btn color="success" class="mr-3" :loading="saveProgress" @click.native="saveForm()" :disabled="saveProgress">Enregistrer</v-btn>
        <v-btn color="primmary" href="/#/sar/">Retour</v-btn>
    </div>
</v-container>
</template>

<script>
import dateLocale from '../services/dateLocale';
import autoCompMulti    from '../components/Autocomplete_multi.vue'

export default {
    name: 'saredit',
    props: [],
    data: function () {
        return {
            saveProgress: false,         // Enregistrement en cours...
            loading: { getItem: true },
            form:{
                sar_id : 0, sar_code : '', sar_reg_code : '', sar_dep_id: null,
                sar_name : '', sar_concerned : 1, sar_order : 0,
                sar_created_at : '', sar_updated_at : '',
            },
            locDateFormat: dateLocale, // Format de date
            autoComplete: {
                sar_dep_id: null
            },
            autoCompleteSource:{
                dep: []
            },
        }
    },
    mounted:function (){
        if( parseInt( this.$route.params.sar_id ) > 0 && this.$route.params.sar_id !== undefined ){
            this.getItem()
        } else {
            this.loading.getItem = false
        }
    },
    methods: {
        getItem(){
            this.$http.get( '/smallagrregion/' + this.$route.params.sar_id + '?include=department' )
            .then( (response) => {
                var prop
                for( prop in response.data.data ){
                    if( typeof response.data.data[prop] === 'object' && response.data.data[prop] !== null && response.data.data[prop]['data'] !== undefined ){
                        this.form[prop] = response.data.data[prop]['data']
                    } else {
                        this.form[prop] = response.data.data[prop]
                    }
                }
                if( this.form.department ){
                    this.autoCompleteSource.dep.push(this.form.department)
                    this.autoComplete.sar_dep_id = this.form.sar_dep_id
                }
                this.loading.getItem = false
            })
            .catch( (error) => {
                this.$root.$toast({ color: 'warning', text: error })
            })
        },
        saveForm () {
            // Enregistrement du formulaire
            this.form.sar_dep_id       = this.autoComplete.sar_dep_id || null
            this.saveProgress = true
            if( parseInt( this.$route.params.sar_id ) > 0 ){
                this.$http.put( '/smallagrregion/' + this.$route.params.sar_id, this.form )
                .then( () => {
                    this.$root.$toast({ color: 'success', text: 'Fiche enregistrée !' })
                    this.$router.push({ path: '/sar' })
                }).catch( (error) => {
                    this.$root.$toast({ text: 'Erreur lors de l\'enregistrement !', error: error })
                    this.saveProgress = false
                });
            } else {
                this.$http.post( '/smallagrregion/', this.form )
                .then( () => {
                    this.$root.$toast({ color: 'success', text: 'Fiche enregistrée !' })
                    this.$router.push({ path: '/sar' })
                }).catch( (error) => {
                    this.$root.$toast({ text: 'Erreur lors de l\'enregistrement !', error: error })
                });
            }
        }
    },
    components: {
        'auto-multi' : autoCompMulti,
    }
}
</script>